var exports = {
  "kL": "GuildNotificationSettingsModal.module__container___MlFxel",
  "uW": "GuildNotificationSettingsModal.module__section___MlFxel",
  "Gf": "GuildNotificationSettingsModal.module__sectionTitle___MlFxel",
  "yV": "GuildNotificationSettingsModal.module__sectionDescription___MlFxel",
  "nv": "GuildNotificationSettingsModal.module__notificationSection___MlFxel",
  "RG": "GuildNotificationSettingsModal.module__suppressSection___MlFxel",
  "Sj": "GuildNotificationSettingsModal.module__mobilePushSection___MlFxel",
  "dY": "GuildNotificationSettingsModal.module__overridesSection___MlFxel",
  "dr": "GuildNotificationSettingsModal.module__overridesHeader___MlFxel",
  "bY": "GuildNotificationSettingsModal.module__overridesHeaderCell___MlFxel",
  "u1": "GuildNotificationSettingsModal.module__overridesHeaderCellLeft___MlFxel",
  "c": "GuildNotificationSettingsModal.module__overridesHeaderCellMute___MlFxel",
  "IC": "GuildNotificationSettingsModal.module__overrideItem___MlFxel",
  "sr": "GuildNotificationSettingsModal.module__overrideHeader___MlFxel",
  "yW": "GuildNotificationSettingsModal.module__channelInfo___MlFxel",
  "p": "GuildNotificationSettingsModal.module__channelIcon___MlFxel",
  "E8": "GuildNotificationSettingsModal.module__channelDetails___MlFxel",
  "HA": "GuildNotificationSettingsModal.module__channelName___MlFxel",
  "yb": "GuildNotificationSettingsModal.module__categoryName___MlFxel",
  "Z5": "GuildNotificationSettingsModal.module__mobileOverrideOptions___MlFxel",
  "Ue": "GuildNotificationSettingsModal.module__desktopNotificationOptions___MlFxel",
  "of": "GuildNotificationSettingsModal.module__checkboxCell___MlFxel",
  "DT": "GuildNotificationSettingsModal.module__removeButton___MlFxel",
  "kI": "GuildNotificationSettingsModal.module__iconTertiary___MlFxel",
};

module.exports = exports;
